import { render, staticRenderFns } from "./ItemInfo.vue?vue&type=template&id=9f1c2b34&"
import script from "./ItemInfo.vue?vue&type=script&lang=js&"
export * from "./ItemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports